/**
 * @flow
 * @relayHash 2c7cb5bf264b534c5067a21a775db320
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ApplicabilityType = "LOCAL" | "LOCALIZED" | "SYSTEM" | "%future added value";
export type HomeContentQueriesPendingDocumentsQueryVariables = {||};
export type HomeContentQueriesPendingDocumentsQueryResponse = {|
  +pendingDocuments: ?{|
    +documents: ?{|
      +totalCount: ?number,
      +edges: $ReadOnlyArray<?{|
        +node: ?{|
          +id: string,
          +pk: ?number,
          +name: string,
          +bloc: {|
            +name: string
          |},
          +applicabilityType: ?ApplicabilityType,
          +category: {|
            +name: string
          |},
          +effectiveDate: ?string,
          +restricted: boolean,
          +legacyEffectiveDate: ?string,
          +isTemplate: ?boolean,
          +systemDocumentTemplate: ?{|
            +name: ?string
          |},
          +documentsOfTemplate: ?{|
            +documents: ?$ReadOnlyArray<?{|
              +pk: ?number,
              +name: string,
              +bloc: {|
                +pk: ?number,
                +name: string,
              |},
              +applicabilityType: ?ApplicabilityType,
              +category: {|
                +name: string
              |},
              +effectiveDate: ?string,
              +restricted: boolean,
              +legacyEffectiveDate: ?string,
            |}>
          |},
        |}
      |}>,
    |},
    +viewOnlyPks: ?$ReadOnlyArray<?number>,
  |}
|};
export type HomeContentQueriesPendingDocumentsQuery = {|
  variables: HomeContentQueriesPendingDocumentsQueryVariables,
  response: HomeContentQueriesPendingDocumentsQueryResponse,
|};
*/


/*
query HomeContentQueriesPendingDocumentsQuery {
  pendingDocuments(showAll: false) {
    documents(first: 5) {
      totalCount
      edges {
        node {
          id
          pk
          name
          bloc {
            name
            id
          }
          applicabilityType
          category {
            name
            id
          }
          effectiveDate
          restricted
          legacyEffectiveDate
          isTemplate
          systemDocumentTemplate {
            name
            id
          }
          documentsOfTemplate {
            documents {
              pk
              name
              bloc {
                pk
                name
                id
              }
              applicabilityType
              category {
                name
                id
              }
              effectiveDate
              restricted
              legacyEffectiveDate
              id
            }
          }
        }
      }
    }
    viewOnlyPks
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "showAll",
    "value": false,
    "type": "Boolean"
  }
],
v1 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 5,
    "type": "Int"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "totalCount",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "pk",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v6 = [
  v5
],
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "applicabilityType",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "category",
  "storageKey": null,
  "args": null,
  "concreteType": "CategoryType",
  "plural": false,
  "selections": v6
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "effectiveDate",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "restricted",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "legacyEffectiveDate",
  "args": null,
  "storageKey": null
},
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isTemplate",
  "args": null,
  "storageKey": null
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "viewOnlyPks",
  "args": null,
  "storageKey": null
},
v14 = [
  v5,
  v3
],
v15 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "category",
  "storageKey": null,
  "args": null,
  "concreteType": "CategoryType",
  "plural": false,
  "selections": v14
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "HomeContentQueriesPendingDocumentsQuery",
  "id": "cbccf05882acee211ef4ab0ddd752c1d",
  "text": null,
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "HomeContentQueriesPendingDocumentsQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "pendingDocuments",
        "storageKey": "pendingDocuments(showAll:false)",
        "args": v0,
        "concreteType": "PendingDocumentsReportType",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "documents",
            "storageKey": "documents(first:5)",
            "args": v1,
            "concreteType": "DocumentCountableConnection",
            "plural": false,
            "selections": [
              v2,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "DocumentCountableEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "DocumentType",
                    "plural": false,
                    "selections": [
                      v3,
                      v4,
                      v5,
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "bloc",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "BlocType",
                        "plural": false,
                        "selections": v6
                      },
                      v7,
                      v8,
                      v9,
                      v10,
                      v11,
                      v12,
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "systemDocumentTemplate",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "SystemDocumentTemplateType",
                        "plural": false,
                        "selections": v6
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "documentsOfTemplate",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "DocumentsOfTemplateType",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "documents",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "DocumentType",
                            "plural": true,
                            "selections": [
                              v4,
                              v5,
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "bloc",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "BlocType",
                                "plural": false,
                                "selections": [
                                  v4,
                                  v5
                                ]
                              },
                              v7,
                              v8,
                              v9,
                              v10,
                              v11
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          v13
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "HomeContentQueriesPendingDocumentsQuery",
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "pendingDocuments",
        "storageKey": "pendingDocuments(showAll:false)",
        "args": v0,
        "concreteType": "PendingDocumentsReportType",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "documents",
            "storageKey": "documents(first:5)",
            "args": v1,
            "concreteType": "DocumentCountableConnection",
            "plural": false,
            "selections": [
              v2,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "DocumentCountableEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "DocumentType",
                    "plural": false,
                    "selections": [
                      v3,
                      v4,
                      v5,
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "bloc",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "BlocType",
                        "plural": false,
                        "selections": v14
                      },
                      v7,
                      v15,
                      v9,
                      v10,
                      v11,
                      v12,
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "systemDocumentTemplate",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "SystemDocumentTemplateType",
                        "plural": false,
                        "selections": v14
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "documentsOfTemplate",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "DocumentsOfTemplateType",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "documents",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "DocumentType",
                            "plural": true,
                            "selections": [
                              v4,
                              v5,
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "bloc",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "BlocType",
                                "plural": false,
                                "selections": [
                                  v4,
                                  v5,
                                  v3
                                ]
                              },
                              v7,
                              v15,
                              v9,
                              v10,
                              v11,
                              v3
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          v13
        ]
      }
    ]
  }
};
})();
node.text = "query HomeContentQueriesPendingDocumentsQuery {\n  pendingDocuments(showAll: false) {\n    documents(first: 5) {\n      totalCount\n      edges {\n        node {\n          id\n          pk\n          name\n          bloc {\n            name\n            id\n          }\n          applicabilityType\n          category {\n            name\n            id\n          }\n          effectiveDate\n          restricted\n          legacyEffectiveDate\n          isTemplate\n          systemDocumentTemplate {\n            name\n            id\n          }\n          documentsOfTemplate {\n            documents {\n              pk\n              name\n              bloc {\n                pk\n                name\n                id\n              }\n              applicabilityType\n              category {\n                name\n                id\n              }\n              effectiveDate\n              restricted\n              legacyEffectiveDate\n              id\n            }\n          }\n        }\n      }\n    }\n    viewOnlyPks\n  }\n}\n";
(node/*: any*/).hash = '2f0c3c0f0ed649ba44aaf5939047ab90';
module.exports = node;
